<template>
  <div class="out_wrap">
    <el-container>
      <el-main>
        <el-table :data="tableData" stripe>
          <el-table-column label="编号" align="center" min-width="60px">
            <template slot-scope="{ $index }">
              {{ $index + 1 + (searchParam.page - 1) * searchParam.pageSize }}
            </template>
          </el-table-column>
          <el-table-column label="任务名称" show-overflow-tooltip align="center" prop="name" min-width="180px">
          </el-table-column>
          <el-table-column label="巡检周期" show-overflow-tooltip align="center" prop="startDate" min-width="160px">
            <template slot-scope="{ row }">
              <div class="period">
                <el-image fit="contain" :src="row.task_type === 1
                  ? 'https://kc-res.izsw.net/apps/qrobot-inspection-system/dayPeriodIcon.png'
                  : 'https://kc-res.izsw.net/apps/qrobot-inspection-system/weekPeriodIcon.png'
                  "></el-image>
              </div>
              <span class="startDate">{{ row.published_at | dateFilter }}
                {{ row.start_time | timeFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="220px" align="center">
            <template slot-scope="scope">
              <div class="operateBtn-group">
                <el-button class="inspRecord" @click="inspRecord(scope.row)">巡检记录
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="paginationInfo.total" background :page-size.sync="searchParam.pageSize"
          :current-page.sync="searchParam.page" layout="prev, pager, next,slot" :pager-count="11"
          :total="paginationInfo.total" @current-change="getPages">
          <span class="slot">{{
            "共" + paginationInfo.lastPage + "页," + paginationInfo.total + "条"
          }}</span>
        </el-pagination>
        <el-dialog :title="title" :visible.sync="dialogVisible" :before-close="handleClose" :close-on-click-modal="false"
          :modal-append-to-body="false" center class="recordInfoDialog" width="1248px">
          <el-main>
            <el-table :data="recordInfo" stripe>
              <el-table-column label="编号" align="center" min-width="60px">
                <template slot-scope="{ $index }">
                  {{
                    $index +
                    1 +
                    (recordSearchParam.recordPage - 1) *
                    recordSearchParam.recordPageSize
                  }}
                </template>
              </el-table-column>
              <el-table-column label="巡检时间" min-width="120px" prop="recordInfoTime">
                <template slot-scope="{ row }">
                  {{ row.patrol_time }}
                </template>
              </el-table-column>
              <el-table-column label="巡检位置" prop="location">
              </el-table-column>
              <el-table-column label="巡检结果" prop="result">
                <template slot-scope="{ row }">
                  <div style="display: flex;align-items: center;">
                    <el-image :src="row.result == 1
                      ? 'https://kc-res.izsw.net/apps/qrobot-inspection-system/recordCheckIcon.png'
                      : 'https://kc-res.izsw.net/apps/qrobot-inspection-system/recordErrorIcon.png'
                      " style="width: 20px;height: 20px;margin-right: 7px;"></el-image>
                    <span>{{ row.result == 1 ? "正常" : "异常" }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="巡检照片" prop="photo">
                <template slot-scope="{ row }">
                  <div v-if="row.photo.full_url != ''">
                    <el-image style="width: 40px; height: 40px" :src="row.photo.full_url"
                      :preview-src-list="[row.photo.full_url]"></el-image>
                  </div>
                  <span v-else>暂无数据</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination class="detail" v-if="recordPaginationInfo.recordTotal" background
              :page-size.sync="recordSearchParam.recordPageSize" :current-page.sync="recordSearchParam.recordPage"
              layout="prev, pager, next,slot" :pager-count="11" :total="recordPaginationInfo.recordTotal"
              @current-change="getRecordPages">
              <span class="slot">{{
                "共" +
                recordPaginationInfo.recordLastPage +
                "页," +
                recordPaginationInfo.recordTotal +
                "条"
              }}</span>
            </el-pagination>
          </el-main>
        </el-dialog>
      </el-main>
      <footNav :active="activeNav"></footNav>
    </el-container>
  </div>
</template>

<script>
import footNav from "@/components/footNav";
import { taskList } from "@/assets/api/InspectionTaskMG";
import { taskInfo } from "@/assets/api/InspectionRecordMG";
export default {
  name: "InspectionRecord",
  components: {
    footNav
  },
  watch: {
    $route(to, from) {
      this.$route.query.page &&
        (this.searchParam.page = this.$route.query.page * 1);
      this.getTableData();
    }
  },
  data() {
    return {
      selectedUuid: "",
      title: '',
      activeNav: "2",
      // 表格数据
      tableData: [],
      // 页面信息
      searchParam: {
        page: 1, // 当前页数
        pageSize: this.$store.state.limit // 每页条数
      },
      // 分页器信息
      paginationInfo: {
        total: 0, // 总条数
        lastPage: 0 // 总页数
      },
      // 弹窗显隐
      dialogVisible: false,
      // 记录详细信息
      recordInfo: [
      ],
      recordSearchParam: {
        recordPage: 1,
        recordPageSize: 4 // 每页条数
      },
      // 记录分页器信息
      recordPaginationInfo: {
        recordTotal: 0, // 总条数
        recordLastPage: 0 // 总页数
      },

    };
  },
  filters: {
    dateFilter(value) {
      if (value) {
        return value.substring(0, 10).replace(/-/g, "/");
      }
    },
    timeFilter(value) {
      if (value) {
        return value.substring(0, 5);
      }
    }
  },
  created() {
    this.$route.query.page &&
      (this.searchParam.page = this.$route.query.page * 1);
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.loading = true;
      taskList(this.searchParam).then(res => {
        const { code, data, msg } = res;
        if (code == 200) {
          if (!res.data.length && res.current_page > 1) {
            this.searchParam.page--;
            this.$router.replace(
              {
                name: "InspectionRecord",
                query: {
                  page: this.searchParam.page
                }
              },
              () => { }
            );
            return;
          }
          this.tableData = data.data;
          this.paginationInfo.total = data.total;
          this.paginationInfo.lastPage = data.last_page;
          this.loading = false
        }
      })
    },
    inspRecord(row) {
      this.title = row.name;
      this.selectedUuid = row.uuid;
      taskInfo({
        task_uuid: this.selectedUuid,
        page: this.recordSearchParam.recordPage,
        pageSize: this.recordSearchParam.recordPageSize
      }).then(res => {
        const { code, data, msg } = res;
        if (code == 200) {
          this.dialogVisible = true;
          this.recordInfo = data.data;
          this.recordPaginationInfo.recordTotal = data.total;
          this.recordPaginationInfo.recordLastPage = data.last_page;
        }
      })
    },
    handleClose() {
      this.dialogVisible = false;
      this.selectedUuid = '';
      this.recordSearchParam.recordPage = 1;
    },
    getPages(page) {
      this.tableData = [];
      this.$router.replace(
        {
          name: "InspectionRecord",
          query: {
            page
          }
        },
        () => { }
      );
    },
    getRecordPages(page) {
      this.recordSearchParam.recordPage = page;
      taskInfo({
        task_uuid: this.selectedUuid,
        page: this.recordSearchParam.recordPage,
        pageSize: this.recordSearchParam.recordPageSize
      }).then((res) => {
        const { code, data, msg } = res
        if (code == 200) {
          this.recordInfo = data.data;
          this.recordPaginationInfo.recordTotal = data.total;
          this.recordPaginationInfo.recordLastPage = data.last_page;
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
.out_wrap {
  .el-container {
    .el-main {
      & /deep/ .el-table {
        .el-table__header-wrapper {
          margin-bottom: 20px;
        }

        .el-table__cell .cell {
          display: flex;
          align-items: center;
          justify-content: center;

          .period {
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }

          .startDate {
            display: inline-block;
            width: 128px;
          }
        }
      }
    }
  }

  /deep/ .recordInfoDialog {
    width: 1248px;
    height: 602px;
    background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/dialogBg602.png") no-repeat center center/100% 100%;
    left: calc(50% - 624px);
    top: calc(50% - 301px);

    .el-dialog {
      background: transparent;
      margin: 0 !important;
    }

    .el-dialog__header {
      padding-top: 35px;

      .el-dialog__title {
        font-size: $text-middleTitle;
        color: #ffffff;
        line-height: 1;
        display: inline-block;
      }

      .el-dialog__headerbtn {
        width: 25px;
        height: 25px;
        background: url("https://kc-res.izsw.net/apps/qrobot-inspection-system/delIcon.png") no-repeat center center/100% 100%;

        i {
          font-size: 0;
        }
      }
    }

    .el-dialog__body {
      padding: 25px 34px 0;

      .el-main {
        position: static;
      }

      .detail {
        bottom: -35px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/InspectionRecord.vue